module.exports = __webpack_public_path__ + "img/arrow-down.1122326a.svg";